<div class="cmdk-footer__hints" aria-hidden="true">
  @for (hint of hints(); track hint.text) {
    <span class="cmdk-footer__hint">
      @for (cap of hint.keys; track cap.keys) {
        <paper-kbd [keys]="cap.keys" [mod]="cap.mod" [label]="cap.label" size="md" />
      }
      <span class="cmdk-footer__hint-text">{{ hint.text }}</span>
    </span>
  }
</div>

<!-- The palette's only polite live region. Everything else transient goes
     through LiveAnnouncer so two announcements cannot collide. -->
<span class="cmdk-footer__count" role="status" aria-live="polite" data-testid="cmdk-count">
  @if (showCount()) {
    {{ countLabel() }}
  }
</span>
